import { Box } from "@mui/material";
import React from "react";
import { dataStateType } from "src/constants/status";
import { subAccessControlColumns as columns } from "../../Helper";

const GetSubAccessControlTableColumns = ({
  handleOpenPopup,
  handleDelete,
  status,
}) => {
  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        <button
          onClick={() => handleOpenPopup(item, "", "")}
          className="btn btn-warning"
        >
          <i className="bx bx-edit"></i>
        </button>
        <button
          onClick={() => handleDelete(item.id)}
          className="btn btn-danger"
        >
          <i className="bx bx-trash"></i>
        </button>
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetSubAccessControlTableColumns;
